const axios = window.axios;

export default {
  async serviceReg() {
    const url = `/v1/auth/kakao-service-reg-url`;
    const response = await axios.get(url, {params: {type:'intro-pc'}});
    return response;
  },
  async setCardStatus(partSeq, params) {
    const url = `/v1/parts/${partSeq}/cards/status`;
    const result = await axios.put(url, params);
    return result;
  },
  async setMemberAccept(partSeq) {
    const url = `/v1/parts/${partSeq}/members/accept`;
    const result = await axios.post(url);
    return result;
  },
  async serviceReject(params) {
    const url = `/v1/application/service/service-reject`;
    const result = await axios.get(url, {params});
    return result;
  },
  // /v1/application/service/service-suspension
  async serviceSuspension(params) {
    const url = `/v1/application/service/service-suspension`;
    const result = await axios.get(url, {params});
    return result;
  }
};
